import { render, staticRenderFns } from "./MyPageSelect.vue?vue&type=template&id=362c53d4&"
import script from "./MyPageSelect.vue?vue&type=script&lang=js&"
export * from "./MyPageSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports